import React, { ReactNode } from "react";
import { cn } from "@shared/ui/utils/tailwind";

export interface FormSectionProps {
  children: ReactNode;
  title?: string;
  className?: string;
  spacing?: "sm" | "md" | "lg";
}

const SPACING_CLASSES: Record<string, string> = {
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
};

const FormSection: React.FC<FormSectionProps> = ({ children, title, className, spacing = "md" }) => (
  <div className={cn("flex flex-col", SPACING_CLASSES[spacing], className)}>
    {title && <h3 className="text-base font-semibold text-[var(--text-primary)]">{title}</h3>}
    {children}
  </div>
);

export default FormSection;
